import React from 'react';

interface LoyaltyBannerDesktopProps {
  credit: string;
  memberSince?: string;
  titleLine1?: string;
  titleLine2?: string;
  subtitle?: string;
  memberSinceLabel?: string;
  yourCreditLabel?: string;
}

export const LoyaltyBannerDesktop = ({
  credit,
  memberSince,
  titleLine1 = 'Your',
  titleLine2 = 'SkinSociety',
  subtitle = 'Earn Credit. Unlock Perks. Glow Every Step of the Way.',
  memberSinceLabel = 'Member\nSince',
  yourCreditLabel = 'Your Credit',
}: LoyaltyBannerDesktopProps) => {
  return (
    <div
      className="relative w-full h-[112px] rounded-[8px] overflow-hidden"
      style={{ background: 'linear-gradient(to top left, #311275, #754DCC)' }}
    >
      {/* Content */}
      <div className="relative h-full flex items-center justify-between pl-4 pr-6 py-4 z-[1]">
        {/* Left Side - Title and Subtitle */}
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-0">
            <span className="text-primary-100 text-heading-h6 font-bold">{titleLine1} </span>
            <span className="text-primary-100 text-heading-h6 font-bold">{titleLine2}</span>
          </div>
          <p className="text-primary-100 text-label-small">{subtitle}</p>
        </div>

        {/* Right Side - Member Info and Points */}
        <div className="flex items-center gap-4">
          {/* Member Since */}
          {memberSince && (
            <>
              <div className="flex flex-col gap-0.5">
                <p className="text-primary-300 text-label-medium font-semibold whitespace-pre-wrap">
                  {memberSinceLabel}
                </p>
                <p className="text-primary-300 text-label-small">{memberSince}</p>
              </div>

              {/* Vertical Separator */}
              <div className="h-16 w-px bg-primary-300" />
            </>
          )}

          {/* Credit */}
          <div className="flex flex-col gap-1">
            <p className="text-primary-100 text-label-small">{yourCreditLabel}</p>
            <p className="text-white text-heading-h6 font-extrabold">
              {credit}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
